/* Dansk katalog for locale-investments.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'investments.reviewAndEdit': 'Kontrollér og rediger',
  'investments.editSourceFact': 'Rediger kildeoplysning',
  'investments.correctedSourceFactHelp': 'Ret kun oplysninger, du har kontrolleret mod originaldokumentet. Ændringen logges med bruger og tidspunkt.',
  'investments.saveCorrection': 'Gem rettelse',
  'investments.addOptionalComment': 'Tilføj kommentar (valgfri)',
  'investments.reviewNoteOptional': 'Kommentar til kontrollen (valgfri)',
  'investments.openingReconciliation': 'Primo investeringer mod hovedbogen',
  'investments.openingReconciliationHelp': 'Viste primoinvesteringer sammenlignes med investeringskontiene i åbningsbalancen. Afvigelser til og med {{tolerance}} accepteres.',
  'investments.openingRegisterValue': 'Viste investeringer',
  'investments.openingLedgerValue': 'Primo hovedbog',
  'investments.total': 'Sum',
  'investments.openingLedgerMismatch': 'Primoinvesteringer og hovedbog er ikke afstemt.',
  'investments.details': 'Detaljer',
  'investments.eventDetails': 'Hændelsesdetaljer',
  'investments.holdingDetails': 'Beholdningsdetaljer',
  'investments.amount': 'Beløb',
  'investments.openingRepairTaxReason': 'Skattebehandlingen skal bekræftes mod årsopgørelse eller anden dokumentation.',
  'investments.openingRepairReason': 'Primobeholdning dokumenteret og kontrolleret før salget.',
  'investments.authenticationRequired': 'Log ind for at bruge investeringsregistret.',
  'investments.businessInvalid': 'Vælg en gyldig virksomhed.',
  'investments.businessNotFound': 'Virksomhedens regnskabsdata findes ikke.',
  'investments.operationFailed': 'Handlingen kunne ikke fuldføres. Prøv igen.',
  'investments.measurement': 'Dokumenteret værdiansættelsesprincip',
  'investments.cost': 'Kostpris med nedskrivning',
  'investments.fair_value': 'Dagsværdi (betingelserne er dokumenteret)',
  'investments.measurementReview': 'Vælg og dokumentér værdiansættelsesprincippet. Dagsværdi kræver kvalificerende omsætningsaktiver.',
  'investments.valueAboveCost': 'Bogført værdi må ikke overstige kostprisen under det valgte princip.',
  'investments.duplicateInstrument': 'Investeringsklassen er allerede registreret. Brug samme investering på tværs af depoter.',
  'investments.receiptAlreadyBooked': 'Bilaget er allerede bogført. Brug virksomhedsdokumenter til dokumentation, der dækker flere hændelser.',
  'investments.bankMatched': 'Koblet til bank',
  'investments.matchBank': 'Afstem mod banklinje',
  'investments.bankMatchInvalid': 'Banklinjen kan ikke kobles. Opdater, og kontrollér dato, beløb og konto.',
  'investments.bankUnmatchRequired': 'Åbn bankkoblingen i bankafstemningen, før hændelsen tilbageføres.',
  'investments.acquisitionDate': 'Oprindelig anskaffelsesdato (FIFO)',
  'nav.investeringer': 'Investeringer',
  'route.investeringer': 'Investeringer',
  'navhelp.investeringer': 'Aktier, fonde og tilhørende regnskab.',
  'investments.title': 'Investeringer',
  'investments.subtitle': 'Aktier, fonde og dokumenterede hændelser',
  'investments.newInstrument': 'Ny investering',
  'investments.newEvent': 'Ny hændelse',
  'investments.name': 'Navn',
  'investments.kind': 'Type',
  'investments.share': 'Aktie',
  'investments.fund': 'Fond',
  'investments.isin': 'ISIN (valgfri)',
  'investments.issuerCountry': 'Udstederens land (landekode)',
  'investments.accountCode': 'Balancekonto',
  'investments.valuationAccountCode': 'Konto for værdiregulering',
  'investments.taxTreatment': 'Skattebehandling',
  'investments.accountSource.saved_instrument': 'Viderefører den konto, der allerede er gemt for investeringen.',
  'investments.accountSource.opening_balance': 'Foreslået ud fra entydigt navn og saldo i åbningsbalancen.',
  'investments.accountSource.manual': 'Kontoen er valgt manuelt og bruges fremover for investeringen.',
  'investments.accountSource.default': 'Der blev ikke fundet nogen entydig historisk konto. 1810 foreslås uden at stoppe bogføringen.',
  'investments.review': 'Skal afklares',
  'investments.exempt': 'Inden for fritaksmetoden',
  'investments.taxable': 'Fuldt skattepligtig',
  'investments.mixed': 'Blandet aktie- og rentedel',
  'investments.taxReason': 'Grundlag for skattebehandlingen',
  'investments.instrumentId': 'Investering',
  'investments.choose': 'Vælg',
  'investments.instrumentScope': 'Registreringen gælder NOK og NRS 8. Bekræft land, regelsæt og skattekategori mod dokumentationen. Kombinationsfonde skal afklares særskilt.',
  'investments.date': 'Bogføringsdato',
  'investments.reference': 'Unik transaktionsreference',
  'investments.quantity': 'Antal',
  'investments.provider': 'Udbyder / depot',
  'investments.targetProvider': 'Nyt depot',
  'investments.lotId': 'Skattemæssig anskaffelsespost',
  'investments.gross': 'Brutto vederlag / udlodning',
  'investments.fees': 'Omkostninger / honorar',
  'investments.bookCost': 'Regnskabsmæssig kostpris',
  'investments.bookValue': 'Bogført værdi',
  'investments.taxCost': 'Skattemæssig anskaffelsessum',
  'investments.settlementAccount': 'Afregningskonto',
  'investments.evidence': 'Dokumentation',
  'investments.taxConfirmed': 'Jeg har kontrolleret skattebehandlingen for hændelsen og indkomståret.',
  'investments.opening': 'Primobeholdning',
  'investments.purchase': 'Køb',
  'investments.sale': 'Salg',
  'investments.dividend': 'Udbytte / udlodning',
  'investments.annual_income': 'Årsrapporteret renteoplysning',
  'investments.annualIncomeHelp': 'Brug kun, når udbyderen dokumenterer, at årsopgørelsens rente er en indberetningsoplysning uden egen kontant betaling, nye andele eller ændring i bogført eller skattemæssig anskaffelsessum. Der oprettes ingen postering.',
  'investments.liquidation': 'Likvidationsafregning',
  'investments.fee_redemption': 'Indløsning til fondshonorar',
  'investments.transfer': 'Depotflytning',
  'investments.split': 'Split eller skift af andelsklasse',
  'investments.demerger': 'Spaltning',
  'investments.cost_basis_adjustment': 'Ændring af kostpris',
  'investments.valuation': 'Værdiansættelse',
  'investments.targetInstrumentId': 'Modtagende investering',
  'investments.bookCostAdjustment': 'Ændring regnskabsmæssig kostpris',
  'investments.bookValueAdjustment': 'Ændring bogført værdi',
  'investments.taxCostAdjustment': 'Ændring skattemæssig anskaffelsessum',
  'investments.adjustmentAccount': 'Modkonto',
  'investments.demergerHelp': 'Angiv dokumenteret antal og kostpriser, der overføres fra denne investering til den modtagende investering. Hændelsen giver ingen gevinst, tab eller bankbevægelse.',
  'investments.costBasisAdjustmentHelp': 'Brug beløb med fortegn. Ændring i bogført værdi kræver en dokumenteret modkonto.',
  'investments.yearEndAssessment': 'Vurdering ved årsafslutning',
  'investments.yearEndAssessmentHelp': 'Bekræft med dokumentation, at beholdningen videreføres til kostpris, og at der ikke er grundlag for nedskrivning.',
  'investments.saveYearEndAssessment': 'Gem vurdering',
  'investments.transferHelp': 'Flyt hele anskaffelsesposten. Historisk kostpris bevares, og der oprettes ingen bankpostering.',
  'investments.openingHelp': 'Registrér den beholdning, der allerede indgår i åbningsbalancen. Dette opretter ikke en ny postering. Afstem mod hovedbogen.',
  'investments.dividendTaxFraction': 'Skattepligtig andel af udlodningen',
  'investments.dividendThree': '3 % – ordinær fritaksmetode',
  'investments.dividendZero': '0 % – dokumenteret undtagelse',
  'investments.valuationTreatment': 'Type skatteforskel',
  'investments.temporary': 'Midlertidig forskel',
  'investments.permanent': 'Permanent forskel',
  'investments.saveDraft': 'Gem',
  'investments.uploadFirst': 'Upload dokumentation via Dokumentation eller Dokumenter i indstillingerne.',
  'investments.loading': 'Henter investeringsregistret …',
  'investments.unavailable': 'Registret kunne ikke hentes.',
  'investments.supportScope': 'Norske AS, NOK og NRS 8, indkomstårene 2024–2026. Uafklaret eller sammensat skattebehandling kræver gennemgang.',
  'investments.holdings': 'Beholdning',
  'investments.events': 'Hændelser',
  'investments.closing': 'Afstemning og årsafslutning',
  'investments.eventsHelp': 'Køb, salg og andre dokumenterede ændringer i investeringsregistret.',
  'investments.noEvents': 'Ingen hændelser i perioden',
  'investments.noEventsHelp': 'Nye køb og andre ændringer vises her, når de er registreret eller hentet fra investeringsindbakken.',
  'investments.ai': 'AI-behandling',
  'investments.aiBatchTitle': 'AI-behandling af investeringer',
  'investments.aiBatchIntro': 'Upload hele årets investeringsgrundlag samlet. Plumme læser dokumenterne, adskiller hændelser fra kontrolgrundlag og samler det, der skal kontrolleres.',
  'investments.aiBatchLockedHelp': 'Masseupload og samlet AI-behandling kræver et aktivt Plumme-abonnement. Indbakken og manuel registrering er stadig tilgængelige.',
  'investments.aiBatchActivate': 'Se abonnement',
  'investments.aiBatchUpload': 'Upload alle dokumenter',
  'investments.aiBatchSourceOpening': 'Primo og forrige årsopgørelse',
  'investments.aiBatchSourceTransactions': 'Køb, salg, spaltning og ændringer af anskaffelsessum',
  'investments.aiBatchSourceBank': 'Kontoudtog og honorarer',
  'investments.aiBatchSourceAnnual': 'Årsopgørelse eller decemberrapport',
  'investments.aiBatchSummary': 'Status for AI-behandlingen',
  'investments.aiBatchDocuments': 'Dokumenter læst',
  'investments.aiBatchPrepared': 'Forberedt',
  'investments.aiBatchEvidence': 'Kontrolgrundlag',
  'investments.aiBatchExceptions': 'Undtagelser',
  'investments.aiBatchProposalTitle': 'Samlet arbejdsgrundlag',
  'investments.aiBatchProposalHelp': 'Alle fortolkede linjer vises samlet. Brug blyanten til at rette en kildeoplysning. Intet bogføres, før forslaget er godkendt.',
  'investments.aiBatchEmpty': 'Upload dokumenterne for at opbygge det samlede arbejdsgrundlag.',
  'investments.aiBatchOpenArchive': 'Åbn dokumentarkivet',
  'investments.aiBatchApprovalLater': 'Samlet bogføringsforslag og endelig godkendelse opbygges i næste trin.',
  'investments.aiBatchPostingTitle': 'Samlet bogføringspakke',
  'investments.aiBatchPostingHelp': 'Dette er den faktiske foreslåede bogføring. Kildeoplysninger kan redigeres; FIFO, gevinst/tab og posteringer beregnes igen.',
  'investments.aiBatchPreparing': 'Opbygger bogføringspakken …',
  'investments.aiBatchNoDrafts': 'Ingen ubehandlede hændelseskladder er klar til bogføring.',
  'investments.aiBatchRefreshPackage': 'Beregn igen',
  'investments.aiBatchFinalApprove': 'Godkend hele investeringspakken',
  'investments.debit': 'Debet',
  'investments.credit': 'Kredit',
  'investments.fifo': 'FIFO-partier',
  'investments.yearEndBankMissing': 'Bankkobling mangler.',
  'investments.yearEndBankAmbiguous': 'Bankkoblingen er tvetydig.',
  'investments.yearEndBankMatchFailed': 'Bankkoblingen kunne ikke gemmes.',
  'investments.missing_tax_realization_confirmation': 'Skattemæssig realisationsbekræftelse mangler.',
  'investments.missingTaxRealizationOverrideHelp': 'Decemberrapporten dokumenterer ikke skattemæssige realisationer. Upload års-/realisationsopgørelsen, eller dokumentér, hvorfor du tilsidesætter denne kontrol.',
  'investments.overrideReason': 'Begrundelse og konsekvens',
  'investments.recordOverride': 'Registrér sporbar tilsidesættelse',
  'investments.aiBatchStatus.prepared': 'Klar til forslag',
  'investments.aiBatchStatus.draft': 'Kladde',
  'investments.aiBatchStatus.posted': 'Bogført',
  'investments.aiBatchStatus.evidence': 'Kontrolgrundlag',
  'investments.aiBatchStatus.exception': 'Skal afklares',
  'investments.investmentAiBatchSubscriptionRequired': 'Aktivt abonnement kræves til samlet AI-behandling.',
  'investments.refresh': 'Opdater',
  'investments.edit': 'Redigér',
  'investments.empty': 'Registrér en investering, og tilføj primobeholdning eller et køb.',
  'investments.status': 'Status',
  'investments.actions': 'Handlinger',
  'investments.draft': 'Kladde',
  'investments.posted': 'Godkendt',
  'investments.reversed': 'Tilbageført',
  'investments.preview': 'Se bogføringsforslag',
  'investments.discard': 'Fjern kladde',
  'investments.reverse': 'Tilbagefør hændelse',
  'investments.reconciliation': 'Afstemning mod hovedbogen',
  'investments.ledgerValue': 'Hovedbog',
  'investments.difference': 'Afvigelse',
  'investments.closingHelp': 'Registrér en dokumenteret værdiansættelse pr. 31. december for hver beholdning. Afvigelser og åbne kladder skal løses, før skatteforskellene overføres til årsafslutningen. Beholdningen videreføres til næste år.',
  'investments.taxDifferences': 'Skatteforskelle',
  'investments.note': 'Grundlag for værdipapirnote',
  'investments.reviewNote': 'Kommentar til kontrollen',
  'investments.reviewClosing': 'Godkend afstemning, og overfør skatteforskelle',
  'investments.closingReviewed': 'Investeringsgrundlaget er kontrolleret og overført.',
  'investments.proposal': 'Bogføringsforslag',
  'investments.noJournal': 'Opdaterer registret uden ny hovedbogspostering.',
  'investments.bookProfit': 'Regnskabsmæssigt resultat',
  'investments.taxProfit': 'Skattemæssigt resultat',
  'investments.approve': 'Godkend og bogfør',
  'investments.existingPostingTitle': 'Allerede bogført',
  'investments.existingPostingHelp': 'Denne hovedbogspostering afstemmes samlet mod hændelserne på datoen. Knyt hændelserne uden at bogføre igen.',
  'investments.existingPostingNote': 'Kontrolnotat',
  'investments.linkExistingPosting': 'Knyt til {{voucher}} ({{count}} hændelser)',
  'investments.reverseHelp': 'Senere godkendte hændelser skal tilbageføres først. Tilbageførslen føres i den oprindelige åbne periode og bevares i historikken.',
  'investments.confirmReverse': 'Bekræft tilbageførsel',
  'investments.evidenceRequired': 'Dokumentation og unik reference mangler.',
  'investments.quantityRequired': 'Angiv et positivt antal.',
  'investments.lotQuantityInvalid': 'Antallet overstiger beholdningen. Skattemæssig anskaffelsessum beregnes med FIFO.',
  'investments.feeMustMatchRedemption': 'Honorar og indfrielsesbeløb skal være ens.',
  'investments.dividendFeesReview': 'Udlodning med omkostninger skal behandles særskilt.',
  'investments.fullLotTransferRequired': 'Vælg hele anskaffelsesposten og et nyt depot.',
  'investments.positionRequired': 'Registrér beholdningen først.',
  'investments.valuationTaxReview': 'Værdiansættelsens skattebehandling skal afklares.',
  'investments.annualIncomeScopeReview': 'Årsrapporteret renteoplysning understøttes kun for dokumenterede, fuldt skattepligtige fonde.',
  'investments.annualIncomeDateRequired': 'Årsrapporteret renteoplysning skal dateres 31. december.',
  'investments.taxReviewRequired': 'Kontrollér og dokumentér skattebehandlingen.',
  'investments.bankAccountRequired': 'Vælg en aktiv bankkonto.',
  'investments.demergerTargetRequired': 'Vælg en anden modtagende investering til spaltningen.',
  'investments.demergerBasisInvalid': 'De anskaffelsessummer, der flyttes, må ikke overstige beholdningens grundlag.',
  'investments.demergerMeasurementUnsupported': 'Spaltning understøttes indtil videre kun for investeringer målt til kostpris.',
  'investments.basisAdjustmentRequired': 'Angiv mindst én ændring af anskaffelsessummen.',
  'investments.basisAdjustmentInvalid': 'Ændringen af anskaffelsessummen ville give et negativt grundlag.',
  'investments.basisAdjustmentMeasurementUnsupported': 'Ændring af anskaffelsessum understøttes indtil videre kun for investeringer målt til kostpris.',
  'investments.adjustmentAccountRequired': 'Vælg modkonto, når den bogførte værdi ændres.',
  'investments.openingYearInvalid': 'Årsopgørelsen kan kun bruges som primo for rapportåret eller næste år, når rapportdatoen er 31.12.',
  'investments.unbalanced': 'Forslaget balancerer ikke.',
  'investments.dateInvalid': 'Vælg en gyldig dato.',
  'investments.scopeUnsupported': 'Dette flow understøtter norske AS i 2024–2026.',
  'investments.amountRequired': 'Et nødvendigt beløb mangler.',
  'investments.amountInvalid': 'Kontrollér beløbet.',
  'investments.instrumentInvalid': 'Kontrollér investeringens type, konto og regelsæt.',
  'investments.instrumentReviewRequired': 'Dokumentér investeringens skattebehandling.',
  'investments.evidenceNotFound': 'Dokumentationen findes ikke i denne virksomhed.',
  'investments.eventInvalid': 'Ugyldig hændelse.',
  'investments.dividendFractionInvalid': 'Vælg en dokumenteret skattepligtig andel.',
  'investments.instrumentHasHistory': 'Investeringen har godkendte hændelser. Historikken kan ikke ændres direkte.',
  'investments.issuerCountryRequired': 'Angiv udstederens land.',
  'investments.instrumentNotFound': 'Investeringen findes ikke.',
  'investments.eventImmutable': 'Brug tilbageførsel for godkendte hændelser.',
  'investments.duplicateEvent': 'En hændelse med denne reference er allerede registreret.',
  'investments.eventNotFound': 'Hændelsen findes ikke.',
  'investments.chronologyRequired': 'Godkend hændelserne i datorækkefølge.',
  'investments.openingMustPrecedeActivity': 'Primobeholdning skal dateres 1. januar før andre hændelser.',
  'investments.proposalStale': 'Grundlaget er ændret. Hent et nyt forslag.',
  'investments.reverseLatestFirst': 'Tilbagefør den senest godkendte hændelse først.',
  'investments.existingPostingMismatch': 'Den eksisterende postering stemmer ikke med den samlede investeringsafregning.',
  'investments.existingPostingUnlinkRequired': 'Fjern koblingen til den eksisterende hovedbogspostering, før hændelsen tilbageføres.',
  'investments.reasonRequired': 'Skriv en begrundelse.',
  'investments.actionInvalid': 'Handlingen understøttes ikke.',
  'investments.documentPostedCannotDelete': 'Et bogført investeringsdokument kan ikke flyttes til papirkurven.',
  'investments.documentInUseCannotTrash': 'Dokumentet bruges af en investeringskladde. Slet kladden, før dokumentet flyttes til papirkurven.',
  'investments.sourceReviewedConfirmation': 'Jeg har visuelt kontrolleret originaldokumentet mod beløb, dato, fond og antal.',
  'investments.draftsPending': 'Der findes ubehandlede kladder.',
  'investments.ledgerMismatch': 'Register og hovedbog stemmer ikke.',
  'investments.valuationRequired': 'Årets værdiansættelse mangler for',
  'investments.holdingQuantityMismatch': 'Dokumenteret årsbeholdning stemmer ikke med antallet andele i registeret for',
  'investments.closingReviewRequired': 'Investeringsgrundlaget skal kontrolleres før årsafslutning.',
  'investments.taxPackageChanged': 'Skatteforskellene er ændret. Afstem og overfør igen.',
  'investments.useInvestmentWorkflow': 'Rediger denne postering via Investeringer.',
});
